"use strict";
import angular from "angular";
import tritonContentTargetingHtmlUrl from "./views/tritonContentTargeting.html";

let app = angular.module("app.tritonContentTargeting.component", []);

app.component("tritonContentTargeting", {
    bindings: {
        showActions: "=",
        clusterId: "=",
        model: "=",
        selectedTritonContentTargeting: "=",
    },
    templateUrl: tritonContentTargetingHtmlUrl,

    controller: function ($scope, $ioAlert, FormService) {
        var self = this;
        self.isMainDialogOpen = false;
        self.isHourOfDayDialogOpen = false;
        self.isDayOfWeekDialogOpen = false;
        self.matchType = true;
        self.isSummaryView = false;
        self.summaryOrder = [];
        self.tempChips = {
            stationPodcast: [],
            stationPodcastGenre: [],
            stationPodcastMarket: [],
            stationPodcastPublisher: []
        };
        self.selectedItems = {
            stationPodcast: {},
            stationPodcastGenre: {},
            stationPodcastMarket: {},
            stationPodcastPublisher: {}
        };
        self.chipsByKey = {
            stationPodcast: [],
            stationPodcastGenre: [],
            stationPodcastMarket: [],
            stationPodcastPublisher: []
        };
        self.labelMap = {
            stationPodcast: 'Station/podcast (any)',
            stationPodcastGenre: 'Station/podcast genre (any)',
            stationPodcastMarket: 'Station/podcast market (any)',
            stationPodcastPublisher: 'Sub-publisher (any)'
        };

        self.editKey = function (key) {
            self.openModal(key);
        };


        // Dialog controls
        self.openMainDialog = () => (self.isMainDialogOpen = true);
        self.closeMainDialog = function () {
            self.isMainDialogOpen = false;
            self.selectedModalType = null;

            Object.keys(self.tempChips).forEach(key => {
                self.tempChips[key] = [];
            });
        };

        self.getModalTitle = function() {
            switch (self.selectedModalType) {
                case 'stationPodcast': return 'Station/podcast';
                case 'stationPodcastGenre': return 'Station/podcast genre';
                case 'stationPodcastMarket': return 'Station/podcast market';
                case 'stationPodcastPublisher': return 'Sub-publisher';
                default: return '';
            }
        };

        self.closeModal = function () {
            if (self.selectedModalType) {
                self.tempChips[self.selectedModalType] = [];
            }
            self.selectedModalType = null;
        };

        self.openModal = function(type) {
            self.cache = {};
            self.selectedModalType = type;
            self.isLoading = true;
            self.data = [];

            self.tempChips[type] = angular.copy(self.chipsByKey[type] || []);
            self.selectedItems[type] = {};

            (self.tempChips[type] || []).forEach(chip => {
                self.selectedItems[type][chip.id] = true;
            });

            self.selectAll[type] = self.data.length > 0 && self.data.every(item => {
                return self.selectedItems[type][item.id];
            });

            const typeFormatters = {
                stationPodcast: (item) => {
                    const marketParent = item.parent_list?.find(p => p.type === 'MARKET_BROADCASTER');
                    return {
                        selected: false,
                        id: item.id,
                        name: item.display_name || item.name,
                        subName: item.name,
                        externalId: item.external_id ?? null,
                        market: marketParent?.name ?? null,
                        marketId: marketParent?.id ?? null
                    };
                },
                stationPodcastGenre: (item) => ({
                    selected: false,
                    id: item.stations.join(','),
                    name: item.name,
                    subName: null
                }),
                stationPodcastMarket: (item) => ({
                    selected: false,
                    id: item.id,
                    name: item.display_name,
                    subName: item.name
                }),
                stationPodcastPublisher: (item) => ({
                    selected: false,
                    id: item.id,
                    name: item.display_name,
                    subName: item.name
                })
            };

            if (!typeFormatters[type]) return;

            if (self.cache[type]) {
                self.data = self.cache[type];
                self.isLoading = false;
                return;
            }

            FormService.getStationPodcastForTriton(self.clusterId, type).then(function (data) {
                const formattedData = data.data.map(typeFormatters[type]);
                self.cache[type] = formattedData;
                self.data = formattedData;
                self.selectAll[type] = self.data.length > 0 && self.data.every(item => {
                    return self.selectedItems[type][item.id];
                });
                self.isLoading = false;
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', error);
                self.isLoading = false;
            });
        };

        self.goBackToMain = () => {
            self.isMainDialogOpen = true;
            self.selectedModalType = null;
        };

        self.addRuleAndContinue = function () {
            self.addRule();
            self.isMainDialogOpen = true;
            self.selectedModalType = null;
        };

        self.toggleItem = function(type, item) {
            const selectedMap = self.selectedItems[type];
            const chips = self.tempChips[type];

            if (selectedMap[item.id]) {
                if (!chips.find(c => c.id === item.id)) {
                    chips.push({
                        id: item.id,
                        name: item.name,
                        subName: item.subName,
                        match: self.matchType
                    });
                }
            } else {
                const index = chips.findIndex(c => c.id === item.id);
                if (index !== -1) {
                    chips.splice(index, 1);
                }
            }

            const allSelected = Object.keys(selectedMap).length &&
                Object.values(selectedMap).every(Boolean);
            self.selectAll[type] = allSelected;
        };

        self.selectAll = {};

        self.toggleSelectAll = function(type) {
            const isChecked = self.selectAll[type];
            const selectedMap = self.selectedItems[type] || (self.selectedItems[type] = {});
            const chips = [];

            self.data.forEach(item => {
                selectedMap[item.id] = isChecked;

                if (isChecked) {
                    chips.push({
                        id: item.id,
                        name: item.name,
                        subName: item.subName,
                        match: self.matchType
                    });
                }
            });

            self.tempChips[type] = isChecked ? chips : [];
        };

        self.removeChip = function(type, index) {
            const chip = self.tempChips[type][index];
            if (chip) {
                self.tempChips[type].splice(index, 1);
                if (self.selectedItems[type]) {
                    self.selectedItems[type][chip.id] = false;
                }
            }

            self.selectAll[type] = Object.values(self.selectedItems[type]).every(Boolean);
        };

        self.clearAllChips = function(type) {
            self.tempChips[type] = [];

            if (self.selectedItems[type]) {
                Object.keys(self.selectedItems[type]).forEach(id => {
                    self.selectedItems[type][id] = false;
                });
            }

            self.selectAll[type] = false;
        };

        self.closeDialog = function (dialogType) {
            if (dialogType === "hourOfDay") {
                self.closeHourOfDayDialog();
                self.tempHourOfDayChips = angular.copy(self.hourOfDayChips);
            }
            if (dialogType === "dayOfWeek") {
                self.closeDayOfWeekDialog();
                if (self.tempDayOfWeekChips) {
                    Object.keys(self.selectedDayOfWeek).forEach((day) => {
                        self.selectedDayOfWeek[day] = false;
                    });
                }
                self.tempDayOfWeekChips = angular.copy(self.dayOfWeekChips);
            }
        };

        self.closeAllDialogs = () => {
            self.isMainDialogOpen = false;
            self.isHourOfDayDialogOpen = false;
        };

        self.setMatch = function (match) {
            self.matchType = match;

            const currentType = self.selectedModalType;
            const chips = self.tempChips[currentType];

            if (Array.isArray(chips)) {
                self.tempChips[currentType] = chips.map(chip => ({
                    ...chip,
                    match: match
                }));
            }
        };

        self.getFormattedChipText = function(chip, key) {
            if (key === 'stationPodcastGenre') {
                return chip.name;
            }
            return chip.name || chip.id;
        };

        self.getChipsForKey = function(key) {
            if (self.selectedModalType === key && self.tempChips[key]) {
                return self.tempChips[key];
            }
            return self.chipsByKey[key] || [];
        };

        self.addRule = function () {
            const modalOrder = [
                'stationPodcast',
                'stationPodcastGenre',
                'stationPodcastMarket',
                'stationPodcastPublisher'
            ];

            const typeToDimension = {
                stationPodcast: 'station',
                stationPodcastGenre: 'station-genre-shoutcast',
                stationPodcastMarket: 'station-market',
                stationPodcastPublisher: 'station-group'
            };

            const ruleBlocksMap = {};

            modalOrder.forEach((type) => {
                const chips = self.tempChips[type];
                if (!chips || !chips.length) return;

                self.chipsByKey[type] = angular.copy(chips);

                if (!self.summaryOrder.includes(type)) {
                    self.summaryOrder.push(type);
                }

                const hasNegativeMatch = chips.some(chip => chip.match === false);

                const values = chips.map(chip => {
                    const rawValue = type === 'stationPodcastGenre' ? chip.name : chip.id;
                    return String(rawValue);
                })

                const baseRule = {
                    type: 'in',
                    dimension: typeToDimension[type],
                    values
                };

                const finalRule = hasNegativeMatch
                    ? { type: 'and', fields: [{ type: 'not', field: baseRule }] }
                    : { type: 'and', fields: [baseRule] };

                ruleBlocksMap[type] = finalRule;
            });

            const sortedRuleBlocks = modalOrder
                .map(type => ruleBlocksMap[type])
                .filter(Boolean);

            if (!sortedRuleBlocks.length) return;

            if (!self.selectedTritonContentTargeting || Object.keys(self.selectedTritonContentTargeting).length === 0) {
                self.selectedTritonContentTargeting = {
                    targeting_type: 'content',
                    rules: {
                        type: 'or',
                        fields: [{ type: 'and', fields: [] }]
                    }
                };
            }

            const andBlock = self.selectedTritonContentTargeting.rules.fields.find(rule => rule.type === 'and');
            if (!andBlock) return;

            const usedDimensionsThisRound = Object.keys(ruleBlocksMap).map(type => typeToDimension[type]);

            andBlock.fields = andBlock.fields.filter(existingRule => {
                if (existingRule.type === 'and' && Array.isArray(existingRule.fields)) {
                    return !existingRule.fields.some(f => {
                        if (f.type === 'in' && usedDimensionsThisRound.includes(f.dimension)) return true;
                        if (f.type === 'not' && f.field && typeof f.field === 'object') {
                            return usedDimensionsThisRound.includes(f.field.dimension);
                        }
                        return false;
                    });
                }
                return true;
            });


            andBlock.fields.push(...sortedRuleBlocks);

            self.selectedTritonContentTargeting.meta = self.selectedTritonContentTargeting.meta || {};
            modalOrder.forEach(type => {
                self.selectedTritonContentTargeting.meta[type] = angular.copy(self.chipsByKey[type]);
            });

            modalOrder.forEach(type => {
                self.tempChips[type] = [];
            });

            self.selectedModalType = null;
            self.isSummaryView = true;
            self.isMainDialogOpen = false;
        };

        self.showSummaryView = () => {
            self.isSummaryView = true;
            self.isMainDialogOpen = false;
        };

        self.deleteSet = () => {
            self.isSummaryView = false;
            self.selectedTritonContentTargeting = [];

            self.tempChips = {
                stationPodcast: [],
                stationPodcastGenre: [],
                stationPodcastMarket: [],
                stationPodcastPublisher: []
            };

            self.chipsByKey = {
                stationPodcast: [],
                stationPodcastGenre: [],
                stationPodcastMarket: [],
                stationPodcastPublisher: []
            };

            self.selectedItems = {
                stationPodcast: {},
                stationPodcastGenre: {},
                stationPodcastMarket: {},
                stationPodcastPublisher: {}
            };

            self.summaryOrder = [];
            self.selectAll = {};
            self.matchType = true;
        };

        self.hasSummaryData = function () {
            return self.summaryOrder && self.summaryOrder.length > 0 &&
                self.summaryOrder.some(function(key) {
                    return self.getChipsForKey(key) && self.getChipsForKey(key).length > 0;
                });
        };

        self.cancelKey = function(key) {
            if (self.chipsByKey && self.chipsByKey[key]) {
                delete self.chipsByKey[key];
            }

            const index = self.summaryOrder.indexOf(key);
            if (index !== -1) {
                self.summaryOrder.splice(index, 1);
            }

            if (self.selectedItems && self.selectedItems[key]) {
                delete self.selectedItems[key];
            }

            if (self.tempChips && self.tempChips[key]) {
                self.tempChips[key] = [];
            }

            if (self.selectAll && self.selectAll[key] !== undefined) {
                self.selectAll[key] = false;
            }

            if (self.selectedModalType === key) {
                self.selectedModalType = null;
            }

            if (self.selectedTritonContentTargeting &&
                self.selectedTritonContentTargeting.rules &&
                self.selectedTritonContentTargeting.rules.fields
            ) {
                const typeToDimension = {
                    stationPodcast: 'station',
                    stationPodcastGenre: 'station-genre-shoutcast',
                    stationPodcastMarket: 'station-market',
                    stationPodcastPublisher: 'station-group'
                };

                const dimension = typeToDimension[key];
                const orFields = self.selectedTritonContentTargeting.rules.fields;

                orFields.forEach(rule => {
                    if (rule.type === 'and' && Array.isArray(rule.fields)) {
                        rule.fields = rule.fields.filter(field => {
                            if (field.type === 'and' && Array.isArray(field.fields)) {
                                return !field.fields.some(f =>
                                    (f.type === 'in' && f.dimension === dimension) ||
                                    (f.type === 'not' && f.field?.dimension === dimension)
                                );
                            }
                            return true;
                        });
                    }
                });

                if (self.selectedTritonContentTargeting.meta && self.selectedTritonContentTargeting.meta[key]) {
                    delete self.selectedTritonContentTargeting.meta[key];
                }
            }
        };

        self.initComponent = function () {
            self.tempChips = {
                stationPodcast: [],
                stationPodcastGenre: [],
                stationPodcastMarket: [],
                stationPodcastPublisher: []
            };

            self.selectedItems = {
                stationPodcast: {},
                stationPodcastGenre: {},
                stationPodcastMarket: {},
                stationPodcastPublisher: {}
            };

            self.selectAll = {};

            if (
                self.selectedTritonContentTargeting &&
                typeof self.selectedTritonContentTargeting === "string"
            )
            {
                self.selectedTritonContentTargeting = JSON.parse(self.selectedTritonContentTargeting);

                const targeting = self.selectedTritonContentTargeting;
                if (!targeting || !targeting.rules || !targeting.rules.fields) return;

                self.chipsByKey = {
                    stationPodcast: [],
                    stationPodcastGenre: [],
                    stationPodcastMarket: [],
                    stationPodcastPublisher: []
                };
                self.summaryOrder = [];

                if (targeting.meta) {
                    Object.keys(targeting.meta).forEach(type => {
                        const chips = angular.copy(targeting.meta[type]);

                        if (!chips || !chips.length) return;

                        self.chipsByKey[type] = chips;
                        self.tempChips[type] = chips;

                        if (!self.selectedItems[type]) {
                            self.selectedItems[type] = {};
                        }

                        chips.forEach(chip => {
                            self.selectedItems[type][chip.id] = true;
                        });

                        self.selectAll[type] = Object.values(self.selectedItems[type]).every(Boolean);

                        if (!self.summaryOrder.includes(type)) {
                            self.summaryOrder.push(type);
                        }
                    });
                }

                self.isSummaryView = self.summaryOrder.length > 0;

                if (self.showActions) {
                    self.editMode = false;
                    self.enableViewMode = true;
                    self.isSummaryView = true;
                    self.isMainDialogOpen = false;
                } else {
                    self.enableViewMode = true;
                    self.isSummaryView = true;
                    self.isMainDialogOpen = false;
                }
            } else {
                self.enableViewMode = false;
                self.isSummaryView = false;
                self.isMainDialogOpen = false;
                self.editMode = false;
                self.selectedTritonContentTargeting = [];
            }
        };

        self.initComponent();
    },
});
